import React from "react";
import PropTypes from "prop-types";

import Link from "shared/components/Link";
import Overlay from "shared/components/FullscreenOverlay";
import _str from "shared/util/_str";
import isSpa from "shared/util/isSpa";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";

import "./ProfileMenu.scss";

const ProfileMenu = ({ isOpen, isFlagMod, onClose }) => {
	if (!isOpen) return null;

	const PROFILE_MENU_LINKS = [
		{
			displayText: _str("Profile"),
			path: "/profile",
			noSpa: !isSpa(),
		},
		{
			displayText: _str("Settings"),
			path: "/settings",
			noSpa: !isSpa(),
		},
		{
			displayText: _str("Help"),
			path: "https://help.okcupid.com/",
			target: "_blank",
			noSpa: true,
		},
		{
			displayText: _str("Sign Out"),
			path: "/logout",
			noSpa: !isSpa(),
		},
	];

	if (isFlagMod) {
		const FLAG_MOD_LINK = {
			displayText: _str("Review Photos"),
			path: "/flagmod",
			noSpa: true,
		};

		// Place flagmod before sign out.
		const signOutIndex = PROFILE_MENU_LINKS.findIndex(({ path }) => path === "/logout");
		PROFILE_MENU_LINKS.splice(signOutIndex, 0, FLAG_MOD_LINK);
	}

	return (
		<React.Fragment>
			<div className="profile-menu">
				{PROFILE_MENU_LINKS
					.map((menuLink) => (
						<Link
							key={menuLink.displayText}
							to={menuLink.path}
							className="profile-menu-link"
							onClick={() => {
								selectedOptionOnNavBarEvent(menuLink.displayText);
								onClose();
							}}
							target={menuLink.target}
							noSpa={menuLink.noSpa}
						>
							{menuLink.displayText}
						</Link>
					))
				}
			</div>
			<Overlay onClick={onClose} />
		</React.Fragment>
	);
};

ProfileMenu.defaultProps = {
	isFlagMod: false,
	isOpen: false,
};

ProfileMenu.propTypes = {
	isOpen: PropTypes.bool,
	isFlagMod: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
};

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/ProfileMenu.jsx